/* Shared helpers for downloading files (API blobs / client-built CSVs) */

/* Save a blob-typed axios response; filename comes from the
   content-disposition header when present, else the fallback */
export const downloadBlobResponse = (res, fallbackName) => {
  const blob = res?.data instanceof Blob ? res.data : new Blob([res?.data ?? ""]);
  const disposition = res?.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const name = match ? decodeURIComponent(match[1]) : fallbackName;
  saveBlob(blob, name);
};

/* Build a CSV from a header row + data rows and download it */
export const downloadCsv = (headers, rows, filename) => {
  const escape = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const lines = [
    headers.map(escape).join(","),
    ...rows.map((row) => row.map(escape).join(",")),
  ];
  saveBlob(new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" }), filename);
};

const saveBlob = (blob, name) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  window.URL.revokeObjectURL(url);
};
